<template>
    <div class="loadingOuterArea" v-if="this.$store.state.common.isLoading">
        <div class="loadingInnerArea">
            <div class="onmaum-logo">
                
            </div>
            <div class="text-center fs-6 fw-bolder mt-0 onmaum-text-gradient mx-4">
                소중한 고객 정보를 불러오는 중입니다
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingPage',
}
</script>

<style>
.loadingOuterArea {
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 0;
    left: 0;
    padding: 20px;
    z-index: 9998;

    justify-content: center;
    align-items: center;
    display: flex;
}

.loadingInnerArea {
    background: white;
    width: auto;
    height: auto;
    position: relative;
    margin: auto;
    padding: 10px;
    border-radius: 8px;
    color: transparent;
    text-align: -webkit-center;
    border-radius: 5rem;
    border: 0.5rem solid #FF931E;
}

.onmaum-logo {
    background-image: url("@/assets/img/logo.svg");
    width: 10rem;
    height: 10rem;
}

.onmaum-text-gradient {
    background: linear-gradient(45deg, var(--color-1), var(--color-2), var(--color-3), var(--color-4), var(--color-5), var(--color-6), var(--color-7));
    -webkit-background-clip: text;
    background-clip: text;
    animation: changeGradient 1500ms infinite;
}

@keyframes changeGradient {
  0% {
    --color-1: #F44336;
    --color-2: #FF5722;
    --color-3: #FFEB3B;
    --color-4: #4CAF50;
    --color-5: #2196F3;
    --color-6: #3F51B5;
    --color-7: #673AB7;
  }
  16.6% {
    --color-1: #673AB7;
    --color-2: #F44336;
    --color-3: #FF5722;
    --color-4: #FFEB3B;
    --color-5: #4CAF50;
    --color-6: #2196F3;
    --color-7: #3F51B5;
  }
  33.2% {
    --color-1: #3F51B5;
    --color-2: #673AB7;
    --color-3: #F44336;
    --color-4: #FF5722;
    --color-5: #FFEB3B;
    --color-6: #4CAF50;
    --color-7: #2196F3;
  }
  49.8% {
    --color-1: #2196F3;
    --color-2: #3F51B5;
    --color-3: #673AB7;
    --color-4: #F44336;
    --color-5: #FF5722;
    --color-6: #FFEB3B;
    --color-7: #4CAF50;
  }
  66.4% {
    --color-1: #4CAF50;
    --color-2: #2196F3;
    --color-3: #3F51B5;
    --color-4: #673AB7;
    --color-5: #F44336;
    --color-6: #FF5722;
    --color-7: #FFEB3B;
  }
  83% {
    --color-1: #FFEB3B;
    --color-2: #4CAF50;
    --color-3: #2196F3;
    --color-4: #3F51B5;
    --color-5: #673AB7;
    --color-6: #F44336;
    --color-7: #FF5722;
  }
  100% {
    --color-1: #FF5722;
    --color-2: #FFEB3B;
    --color-3: #4CAF50;
    --color-4: #2196F3;
    --color-5: #3F51B5;
    --color-6: #673AB7;
    --color-7: #F44336;
  }
}

</style>